import React from "react";
import "@/App.css";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { Toaster } from "./components/ui/toaster";
import HeaderMinimal from "./components/HeaderMinimal";
import HeroMinimal from "./components/HeroMinimal";
import BrandsMinimal from "./components/BrandsMinimal";
import ServicesMinimal from "./components/ServicesMinimal";
import WorkMinimal from "./components/WorkMinimal";
import SkgPartnership from "./components/SkgPartnership";
import AboutMinimal from "./components/AboutMinimal";
import BerlinFashionWeekGallery from "./components/BerlinFashionWeekGallery";
import ProcessMinimal from "./components/ProcessMinimal";
import CTAMinimal from "./components/CTAMinimal";
import Contact from "./components/Contact";
import FooterMinimal from "./components/FooterMinimal";
import FloatingSocialBar from "./components/FloatingSocialBar";
import MrBunnyChatbot from "./components/MrBunnyChatbot";
import CookieConsent from "./components/CookieConsent";
import Blog from "./components/Blog";
import BlogPost from "./components/BlogPost";
import BlogAdmin from "./components/BlogAdmin";
import PrivacyPolicy from "./components/PrivacyPolicy";
import TermsOfService from "./components/TermsOfService";
import CookiePolicy from "./components/CookiePolicy";
import AboutPage from "./components/AboutPage";
import ContactPage from "./components/ContactPage";

function HomePage() {
  return (
    <>
      <HeroMinimal />
      <BrandsMinimal />
      <ServicesMinimal />
      <WorkMinimal />
      <SkgPartnership />
      <AboutMinimal />
      <BerlinFashionWeekGallery />
      <ProcessMinimal />
      <CTAMinimal />
      <Contact />
    </>
  );
}

function App() {
  return (
    <Router>
      <div className="App bg-black min-h-screen">
        <HeaderMinimal />
        <FloatingSocialBar />
        <MrBunnyChatbot />
        <main>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/blog" element={<Blog />} />
            <Route path="/blog/:slug" element={<BlogPost />} />
            <Route path="/admin/blog" element={<BlogAdmin />} />
            <Route path="/privacy-policy" element={<PrivacyPolicy />} />
            <Route path="/terms-of-service" element={<TermsOfService />} />
            <Route path="/cookie-policy" element={<CookiePolicy />} />
            <Route path="/about" element={<AboutPage />} />
            <Route path="/contact" element={<ContactPage />} />
          </Routes>
        </main>
        <FooterMinimal />
        <CookieConsent />
        <Toaster />
      </div>
    </Router>
  );
}

export default App;
